import React from "react";
import NotificationService from "../../../services/profile/NotificationService";
import NotificationTypes from "../../../models/interfaces/profile/NotificationTypes";
import Notification from "../../shared/notification/Notification";
import IDynamicNotificationState, { IDynamicNotificationProps } from './DynamicNotification.models'

export default class DynamicNotification extends React.PureComponent<IDynamicNotificationProps, IDynamicNotificationState> {
  notificationService: NotificationService;

  constructor(props: any) {
    super(props);
    this.notificationService = new NotificationService();

    this.state = {
      notifications: [],
    }
  }

  addToShow(id?: string) {
    if (id) this.setState({ notifications: this.state.notifications.filter(item => item.id !== id) });
    this.setState({ viewNotification: this.state.notifications[0] });

    (document.getElementById('notif-sound') as any).play();
  }

  getData() {
    let self = this;

    self.notificationService.getNotification().then(function (response) {
      self.setState({
        notifications: response,
      })
      self.addToShow()
    })
  }

  close(id: string) {
    let self = this
    let ids = [];

    ids.push(id);

    self.notificationService.readNotification(ids).then(function (response) {
      if (response) {
        self.addToShow(id)
      }
    })
  }

  renderTheme(NotificationType: NotificationTypes) {
    switch (NotificationType) {
      case NotificationTypes.Warning:
        return "notify-warning";
      case NotificationTypes.Danger:
        return "notify-danger";
      case NotificationTypes.Successfully:
        return "notify-success";
      default:
        return "notify-warning";
    }
  }


  // playSound = () => {
  //   var audio = new Audio("BarandehsazAppNotification.mp3");
  //   audio.onload(()=>{
  //     audio.play()
  //   })
   
  //   // ( document.getElementById('audio') as any).play()
  // }

  render(): React.ReactNode {
    let { viewNotification } = this.state;
    let content;

    if (viewNotification) {
      content = (
        <>
            <audio src="BarandehsazAppNotification.mp3" autoPlay loop={false} id="notif-sound"></audio>
          {/* <audio id="audio"><source src="src/assest/BarandehsazAppNotification.mp3" type="audio/mp3"></source></audio> */}
          <Notification notification={viewNotification} close={this.close.bind(this)} isVisibleFooter={true} />
        </>
      );
    }

    return (
      <>
        <div>{content}</div>
      </>
    );
  }
}
